<template>
  <div class="hello">
    
  </div>
  <el-row>
    <el-tag class="login_msg" v-show="this.is_login==true">你好:{{this.login_username}}</el-tag>
    <el-button type="primary" v-show="this.is_login==false" @click="this.loginFormVisible = true;"  style="margin: 50px auto"><i></i>登录</el-button>
    <el-button type="primary" v-show="this.is_login==false" @click="this.registerFormVisible = true;"  style="margin: 50px auto"><i></i>注册</el-button>
    <el-button class="logout_btn" type="primary" v-show="this.is_login==true" @click="logout" ><i></i>退出</el-button>
  </el-row>


  <div class="note_wrap" v-show="this.is_login==true">
    <div v-for="(item, i) in notes">
      <el-row v-if="i%4==0">
        <!-- 展示数据的具体内容 -->
        <el-col  :span="6"  v-for="sub_item in notes.slice(i, i+4)">
            <div class="note_div">
              {{ sub_item.content }}
            </div>
          
        
        </el-col>
    
      </el-row>
    </div>
  </div>

  <div class="note_wrap" v-show="this.is_login==false">
    <div v-for="(item, i) in notes_sample">
      <el-row v-if="i%4==0">
        <!-- 展示数据的具体内容 -->
        <el-col  :span="6"  v-for="sub_item in notes_sample.slice(i, i+4)">
            <div class="note_div">
              {{ sub_item.content }}
            </div>
          
        
        </el-col>
    
      </el-row>
    </div>
  </div>
  
  
  <el-button type="primary" @click="newNote"  style="margin: 50px auto"><i></i>新建便签</el-button>
  <el-tooltip class="item" effect="dark" content="需要提醒服务，可联系下方vx或email" placement="top-start">
    <el-button type="primary" @click="newAlert"  style="margin: 50px 20px"><i></i>新建提醒</el-button>
  </el-tooltip>
  

  <el-dialog title="新建便签" v-model="newNoteFormVisible">
    <el-form :model="form">
    
      <el-form-item label="内容:" :label-width="80">
        <el-input
            placeholder="请输入内容"
            :rows="2"
            type="textarea"
            v-model="note_content">
          </el-input>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="newNoteFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveNote">确 定</el-button>
    </div>
  </el-dialog>

  <el-dialog title="登录" v-model="loginFormVisible">
    <el-form :model="form">
      <el-form-item label="用户名:" :label-width="80">
        <el-input
            placeholder="请输入用户名"
            v-model="login_username">
          </el-input>
      </el-form-item>

      <el-form-item label="密码:" :label-width="80">
        <el-input
            placeholder="请输入密码"
            v-model="login_password">
          </el-input>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="loginFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="login">确 定</el-button>
    </div>
  </el-dialog>

  <el-dialog title="注册" v-model="registerFormVisible">
    <el-form :model="form">
      <el-form-item label="用户名:" :label-width="80">
        <el-input
            placeholder="请输入用户名"
            v-model="register_username">
          </el-input>
      </el-form-item>

      <el-form-item label="密码:" :label-width="80">
        <el-input
            placeholder="请输入密码"
            v-model="register_password">
          </el-input>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="registerFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="register">确 定</el-button>
    </div>
  </el-dialog>

  <el-dialog title="新建提醒" v-model="alertFormVisible">
    <el-form :model="form">
      
      <el-form-item label="时间:" :label-width="80">
        <el-date-picker
          v-model="alert_time"
          type="datetime"
          placeholder="Pick a Date"
          value-format="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>

      <el-form-item label="内容:" :label-width="80">
        <el-input
            placeholder="请输入提醒内容"
            :rows="2"
            type="textarea"
            v-model="alert_content">
          </el-input>
      </el-form-item>


      
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
      <el-button @click="alertFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveAlert">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      is_login: false,
      login_username: '',
      notes: [],
      newNoteFormVisible: false,
      note_title: '',
      note_content: '',

      loginFormVisible: false,
      login_username: '',
      login_password: '',

      registerFormVisible: false,
      register_username: '',
      register_password: '',

      alertFormVisible: false,
      alert_time: '',
      alert_content: '',

      notes_sample: [{'content': '今天要去公园跑步'},
                      {'content': '12月份要去外地旅行'},
                      {'content': '地铁最晚开门时间是11点'},
                      {'content': '明天要早起'},
      ]

    }
  },
  created: function() {
    // 发送 GET 请求获取数据
    function getCookies() {
      // 获取所有的 Cookie 字符串
      const cookieString = document.cookie;
      // 将 Cookie 字符串按照分号分割成多个 Cookie 项
      const cookies = cookieString.split('; ');
      // 遍历每个 Cookie 项
      var ret = {};
      for (let i = 0; i < cookies.length; i++) {
        // 去除每个 Cookie 项两端的空格
        const cookie = cookies[i].trim();
        // 按照等号分割成键值对
        const [name, value] = cookie.split('=');
        ret[name] = value;
      }
      return ret;
    }
    
    var cookie_obj = getCookies();
   
    var username = '';
    for(var cookie in cookie_obj){
      if(cookie == 'usertoken'){
        username = window.atob(cookie_obj['usertoken']);
        this.login_username = username;
        this.is_login = true;
        console.log(this.is_login);
        console.log(this.login_username);
      }

    }

    this.getData();
  },

  methods: {
    getData(){
      var vm = this;
      axios.get('/api')
      .then(response => {
          // 处理响应数据
          const data = response.data;
          console.log(data);
          // 将数据渲染到列表中
          vm.notes = data.data;
        })
      .catch(error => {
          // 处理请求错误
          console.error(error);
        });
    },
    newNote(){
      if(this.is_login == true){
        this.newNoteFormVisible = true;
      }else{
        alert('您尚未登录!')
      }
    },
    newAlert(){
      if(this.is_login == true){
        this.alertFormVisible = true;
      }else{
        alert('您尚未登录!')
      }
    },
    saveNote(){                  
            this.newNoteFormVisible = false;
        
            var vm = this;
            
            var content = this.note_content;
           
            var url = '/api/add';
            var params = {content: content};

            axios.post(url, params, {
                    'Content-Type':'application/json'  
                }).then(function (request) {
                var res = request.data
               
                if (res.status === 0 || res.status === '0') {
                    this.$message.error('保存失败！');
                    return
                }
               
                vm.$message.success('保存成功！');
                //vm.note_title = '';
                vm.note_content = '';
                vm.getData();
                
            }).catch(function (error) {
                vm.loading = false;
                vm.$message.error('保存失败！');
            });
            
        },

    login(){                  
        this.loginFormVisible = false;
    
        var vm = this;
        var username = this.login_username;
        var password = this.login_password;
        
        var url = '/api/login';
        var params = {username: username, password: password};

        axios.post(url, params, {
                'Content-Type':'application/json'  
            }).then(function (request) {
            var res = request.data
            console.log(res);
            if (res.status === 0 || res.status === '0') {
                this.$message.error('登录失败！');
                return
            }
            
            vm.$message.success('登陆成功！');
            
            vm.login_username = '';
            vm.login_passwrod = '';
            //vm.getData();
            window.location.href = '/';
            
        }).catch(function (error) {
            vm.loading = false;
            vm.$message.error('登录失败！');
        });
        
    },

    logout(){                  
        document.cookie = "usertoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        window.location.href = '/';
        
    },

    register(){                  
        this.registerFormVisible = false;
    
        var vm = this;
        var username = this.register_username;
        var password = this.register_password;
        
        var url = '/api/register';
        
        var params = {username: username, password: password};
        console.log(params);
        axios.post(url, params, {
                'Content-Type':'application/json'  
            }).then(function (request) {
            var res = request.data
            
            if (res.status === 0 || res.status === '0') {
                this.$message.error('注册失败！');
                return
            }
            
            vm.$message.success('注册成功！');
            
            vm.register_username = '';
            vm.register_passwrod = '';
            window.location.href = '/';
            //vm.getData();
            
        }).catch(function (error) {
            vm.loading = false;
            vm.$message.error('注册失败！');
        });
        
    },

    saveAlert(){                  
            this.alertFormVisible = false;
        
            var vm = this;
            
            var alert_content = this.alert_content;
            var alert_time = this.alert_time;
           
            var url = '/api/add_alert';
            var params = {alert_time: alert_time, alert_content: alert_content};

            axios.post(url, params, {
                    'Content-Type':'application/json'  
                }).then(function (request) {
                var res = request.data
               
                if (res.status === 0 || res.status === '0') {
                    this.$message.error('保存失败！');
                    return
                }
               
                vm.$message.success('保存成功！');
                vm.alert_time = '';
                vm.alert_content = '';
                vm.getData();
                
            }).catch(function (error) {
                vm.loading = false;
                vm.$message.error('保存失败！');
            });
            
        },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .note_div{
    min-height: 100px;
    border: 1px dashed grey;
    padding: 20px;
    margin: 10px;
    text-align: left;
  }

  .login_msg{
    border:none;
    background:none;
    margin-left: 5%;
    font-size: 14px;
  }

  .logout_btn{
    margin-left: 72%;
  }

  .note_wrap{
    margin: 20px;
  }
</style>
